<template>
  <div class='post'>
    <h3>Comments</h3>
    <div v-for="comment in formattedData" :key="comment.id" class="single">
      <div v-if="user">
        <img :src="user.photoURL" alt="" class="comment-userimg">
          <div>
            <span class="name">Written By {{ user.displayName }}
            </span>
            <span class="created-at">{{ comment.createdAt }}</span>
          </div>
      </div>
      <p>{{ comment.comment }}</p>
    </div>
    <form @submit.prevent="handleSubmit" class="chat-input">
      <textarea placeholder="Type a message and hit enter to send..." v-model="comment" @keypress.enter.prevent="handleSubmit"></textarea>
      <button type="submit" class="send">Send</button>
    </form>
  </div>
</template>

<script>
import getUser from '../composables/getUser'
import { timestamp, projectFirestore } from '../firebase/config'
import getPosts from '../composables/getPosts'
import { computed, ref } from 'vue'
import { formatDistanceToNow } from 'date-fns'

export default {
  props: ['id'],
  setup(props) {
    const { user } = getUser()
    const comment = ref('')
    const { posts, error } = getPosts('comments', ['postid', '==', props.id])
    const formattedData = computed(() => {
      if(posts.value) {
        return posts.value.map((item) => {
          let time = formatDistanceToNow(item.createdAt.toDate())
          return { ...item, createdAt: time}
        })
      }
    })
    const handleSubmit = async () => {
      const cmt = {
        name: user.value.displayName,
        comment: comment.value,
        postid: props.id,
        createdAt: timestamp()
      }
      const res = await projectFirestore.collection('comments').add(cmt)
      comment.value = ''
    }

    return { user, comment, handleSubmit, posts, error, formattedData }
  }
}
</script>

<style scoped>
  .single {
    margin: 15px 0;
    padding: 10px 0;
    border-bottom: 1px solid rgb(235, 235, 235);
  }
  .single>div {
    display: flex;
    align-items: center;
  }
  .comment-userimg {
    display: block;
    width: 64px;
    height: 64px;
    object-position: center center;
    object-fit: cover;
    border-radius: 50%;
  }
  .name {
    font-weight: bold;
    margin-left: 12px;
    display: block;
  }
  .created-at {
    display: inline-block;
    margin-left: 13px;
  }
</style>